<template>
    <div>
        <b-sidebar
            v-model="open"
            title="Detalhes da Redação"
            backdrop-variant="dark"
            width="390px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="essay">
                <dl>
                    <dt>
                        Turma
                    </dt>
                    <dd>
                        {{ essay.group.name }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Aluno
                    </dt>
                    <dd>
                        {{ essay.student.name }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Professor (Corretor)
                    </dt>
                    <dd>
                        <span v-if="essay.teacher">
                            {{ essay.teacher.name }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Nota Final
                    </dt>
                    <dd>
                        <span v-if="essay.status === 'OKAY'">
                            {{ essay.note }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Status
                    </dt>
                    <dd>
                        <span v-if="essay.status === 'BLOCK'" class="text-warning">
                            Aguardando Devolução
                        </span>

                        <span v-if="essay.status === 'WAIT'" class="text-danger">
                            Aguardando Correção
                        </span>

                        <span v-if="essay.status === 'IN_PROGRESS'" class="text-info">
                            Correção em Andamento
                        </span>

                        <span v-if="essay.status === 'OKAY'" class="text-success">
                            Corrigida
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Conteúdo
                    </dt>
                    <dd>
                        <b-button variant="outline-primary" @click="showPreviewContent">
                            Mostrar Redação
                        </b-button>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Modo de Envio
                    </dt>
                    <dd>
                        <span v-if="essay.content_type === 'TEXT'" class="text-secondary">
                            Via Texto
                        </span>

                        <span v-if="essay.content_type === 'IMG'" class="text-primary">
                            Via Imagem
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Tema
                    </dt>
                    <dd>
                        <span v-if="essay.theme">
                            <a :href="'/student/themes/' + essay.theme.id" target="_blank">
                                {{ essay.theme.title | truncate(30) }}
                            </a>
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Modo de Correção
                    </dt>
                    <dd>
                        <span v-if="essay.mode">
                            <span>
                                {{ essay.mode.name }}
                            </span>
                        </span>
                        <span v-else>
                            <span v-if="essay.theme">
                                <span>
                                    {{ essay.theme.mode.name }}
                                </span>
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Enviada
                    </dt>
                    <dd>
                        {{ essay.created_at | moment('from', 'now') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Última Modificação
                    </dt>
                    <dd>
                        {{ essay.updated_at | moment('from', 'now') }}
                    </dd>
                </dl>
            </div>

            <template #footer v-if="essay">
                <div class="d-flex bg-light text-dark align-items-center border-top px-3 py-2">

                    <div class="mr-auto">

                        <a v-if="essay.status === 'WAIT'" href="#" class=" text-danger" v-b-tooltip.hover title="Excluir Redação" @click="destroyEssay">
                            <i class="fas fa-trash-alt mr-1"></i> Excluir
                        </a>

                    </div>

                    <div class="ml-auto">

                    </div>

                </div>
            </template>

        </b-sidebar>

        <!-- Preview Content -->
        <preview></preview>

        <!-- Edit -->
        <edit :modes="modes"></edit>

        <!-- Destroy -->
        <destroy></destroy>

    </div>
</template>

<script>
import Preview from './Preview'
import Edit from "./Edit";
import Destroy from "./Destroy";

export default {
    components: {
        Preview,
        Edit,
        Destroy
    },
    props: ['modes'],
    data() {
        return {
            loadingCorrection: false,
            open: false,
            essay: null
        }
    },
    created() {
        this.$root.$on('essaysShowDetail', (essay) => {
            this.essay = essay
            this.open = true
        })
    },
    methods: {

        showPreviewContent() {
            this.$root.$emit('showPreviewEssay', this.essay)
        },

        destroyEssay() {
            this.$root.$emit('destroyEssay', this.essay)
        },

    }
}
</script>

<style scoped>

</style>
